import { CssType } from 'src/theme/jss-types';

export const FilterUsersDrawerStyles = (): CssType => ({
  drawerContent: {
    padding: 16,
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 16,
  },
});

export default FilterUsersDrawerStyles;
